import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ActivityPlaceModule = lazy(loadModule);

export default ActivityPlaceModule;
